// Numbered so it runs before `load-buckets.server.ts`, which skips its boot fetches in hard maintenance mode.
export default defineNuxtPlugin(async () => {
    const { mode, refresh } = useMaintenance()
    await callOnce('maintenance-state', refresh)

    if (import.meta.server) return

    // Open tabs pick up a mode change on their next navigation: the banner appears, or the page is closed off.
    // Skips the initial client route (already loaded above) and query-only changes such as filters.
    const router = useRouter()
    router.afterEach((to, from) => {
        if (from.matched.length && to.path !== from.path) void refresh()
    })

    // A request the server rejects for maintenance means the mode changed since the last check, so reload it: hard
    // mode then redirects below, soft mode shows the banner. Uploads go through XHR and report it with an event.
    globalThis.$fetch = $fetch.create({
        onResponseError({ response }) {
            if (isMaintenanceRejection(response.status, response._data)) void refresh()
        },
    })
    window.addEventListener(MAINTENANCE_REJECTED_EVENT, () => void refresh())

    const route = useRoute()
    watch(mode, (value) => {
        if (!isMaintenancePageAllowed(value, stripLocalePrefix(route.path))) {
            void navigateTo(maintenancePagePath(route.path))
        }
    })
})
